import { render } from "./ProductMediaReviewComponent.vue?vue&type=template&id=40ec2837"
import script from "./ProductMediaReviewComponent.vue?vue&type=script&lang=js"
export * from "./ProductMediaReviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__